import { action, observable } from 'mobx';
import { api } from '../config';

// Components
import SessionStore from './SessionStore';

let obx = observable({
  // Get ticket types
  ticketTypes: [],
  getTicketTypes: action(function(){
    SessionStore.startLoading('Loading…', 'GetTicketTypes');

    api.get(`/installs/${SessionStore.userData.installSid}/ticketFields`)
      .then(response => {
        obx.ticketTypes = response.data.ticketType;

        // Finish loading
        SessionStore.finishLoading('GetTicketTypes');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get tickets
  tickets: [],
  filteredTickets: [],
  getTickets: action(function(enrollmentSid, examSid){
    SessionStore.startLoading('Loading…', 'GetTickets');

    let query = '?'

    if(typeof enrollmentSid !== 'undefined') {
      query += `enrollmentSid=${enrollmentSid}`
    }

    if(typeof examSid !== 'undefined') {
      query += `&examSid=${examSid}`
    }

    api.get(`/installs/${SessionStore.userData.installSid}/tickets${query}`)
      .then(response => {
        obx.tickets = response.data.results;
        obx.filteredTickets = response.data.results;

        // Finish loading
        SessionStore.finishLoading('GetTickets');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Filter tickets
  filterTickets: action(function(newFilteredTickets){
    obx.filteredTickets = newFilteredTickets;
  }),
  // Get individual ticket
  activeTicket: {},
  getTicket: action(function(ticketSid, bypassLoad){
    if(!bypassLoad) {
      SessionStore.startLoading('Loading…', 'GetTicket');
      obx.activeTicket = {};
    }

    api.get(`/installs/${SessionStore.userData.installSid}/tickets/${ticketSid}`)
      .then(response => {
        obx.activeTicket = response.data;

        // Finish loading
        if(!bypassLoad) {
          SessionStore.finishLoading('GetTicket');
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Post ticket
  postTicket: action(function(data, func){
    SessionStore.startLoading('Loading…', 'PostTicket');

    api.post(`/installs/${SessionStore.userData.installSid}/tickets`, data)
      .then(response => {
        // Finish loading
        func();
        SessionStore.finishLoading('PostTicket');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Post reply
  postReply: action(function(ticketSid, data, func){
    api.post(`/installs/${SessionStore.userData.installSid}/tickets/${ticketSid}`, data)
      .then(response => {
        // Finish loading
        obx.getTicket(ticketSid, true);
        func();
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Update ticket status
  updateTicket: action(function(ticketSid, status){
    const data = {
      status
    }

    api.put(`/installs/${SessionStore.userData.installSid}/tickets/${ticketSid}`, data)
      .then(response => {
        // Finish loading
        obx.getTicket(ticketSid, true);
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
});

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/TicketStore.js